import { create } from "zustand";

import axios from 'axios';
import { baseURL } from "../../baseUrl";

export const useAgency = create((set, get) => ({
    loader: false,
    allAgenciesResult: [],
    allAgenciesPagination: {},
    actions: {

        addRealStateAgency: async (firstName, lastName, mobile, agancyTitle, agancyPhone, stateId, cityId, areaId, guildCode, secretaryName, secretaryMobile, address) => {
            set((state) => ({ loader: true }));
            try {
                const response = await axios.post(
                    `${baseURL}/RealEstateAgancy/AddRealEstateAgancy`,
                    {
                        firstName,
                        lastName,
                        mobile,
                        agancyTitle,
                        agancyPhone,
                        stateId,
                        cityId,
                        areaId,
                        guildCode,
                        secretaryName,
                        secretaryMobile,
                        address
                    },
                    {
                        headers: {
                            accept: "text/plain",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                        },
                    }
                );


                set((state) => ({ loader: false }));
                return response.data; // Return the response data to the calling function
            } catch (error) {
                console.error("Error in API call:", error);
                set((state) => ({ loader: false }));
                set((state) => ({ showServerError: true }));
                throw error; // Rethrow the error to handle it in the calling function
            }
        },
        editRealStateAgency: async (id, firstName, lastName, mobile, agancyTitle, agancyPhone, stateId, cityId, areaId) => {
            set((state) => ({ loader: true }));
            try {
                const response = await axios.post(
                    `${baseURL}/RealEstateAgancy/EditRealEstateAgancy`,
                    {
                        id,
                        firstName,
                        lastName,
                        mobile,
                        agancyTitle,
                        agancyPhone,
                        stateId,
                        cityId,
                        areaId,
                    },
                    {
                        headers: {
                            accept: "text/plain",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                        },
                    }
                );
        

                set((state) => ({ loader: false }));
                return response.data; // Return the response data to the calling function
            } catch (error) {
                console.error("Error in API call:", error);
                set((state) => ({ loader: false }));
                set((state) => ({ showServerError: true }));
                throw error; // Rethrow the error to handle it in the calling function
            }
        },
        getAllAgencies: async (id, mobile, firstName, lastName, agancyTitle, agancyPhone, searchQuery, stateId, cityId, areaId, page, isDeleted) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseURL}/RealEstateAgancy/GetAllRealEstateAgancies`, {
                "id": id,
                "mobile": mobile,
                "firstName": firstName,
                "lastName": lastName,
                "agancyTitle": agancyTitle,
                "agancyPhone": agancyPhone,
                "searchQuery": searchQuery,
                "stateId": stateId,
                "cityId": cityId,
                "areaId": areaId,
                "page": page,
                "isDeleted": isDeleted,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {

                    set((state) => ({ loader: false }))
                    set((state) => ({ allAgenciesResult: res.data.result }))
                    set((state) => ({ allAgenciesPagination: res.data.pagination }))
                }).catch(() => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ showServerError: true }))
                })
        },

        deleteAgency: async (id) => {

            await axios.post(`${baseURL}/RealEstateAgancy/DeleteRealEstateAgancies`,
                { "id": id },
                {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                .then((res) => {
                

                }).catch(() => {

                    set((state) => ({ showServerError: true }))
                })
        },
    }
}))